import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormArray} from '@angular/forms';
import {GenericPayloadModel, GenericPayloadType} from '@cas-hub/acabim-common-client';

@Component({
    selector: 'acabim-user-delete-data',
    templateUrl: './delete-data.component.html',
    styleUrls: ['./delete-data.component.scss']
})
export class DeleteDataComponent implements OnInit {
    @Input() title: string | undefined;
    @Input() data: FormArray | undefined;
    @Input() index: number | undefined;
    dataDetail: GenericPayloadModel[] = [];
    @Output() cancel = new EventEmitter<string>();

    @Input() type: string | undefined;
    detail: string | undefined;
    default: boolean | undefined;

    constructor() {
    }

    ngOnInit(): void {
        if (this.data !== undefined) {
            if (this.type === 'phone') {
                if (this.index != null) {
                    // @ts-ignore
                    this.detail = this.data[this.index].controls.input_ph.value;
                    // @ts-ignore
                    this.default = this.data[this.index].controls.select_ph.value;
                }
            } else if (this.type === 'email') {
                if (this.index != null) {
                    // @ts-ignore
                    this.detail = this.data[this.index].controls.input_em.value;
                    // @ts-ignore
                    this.default = this.data[this.index].controls.select_em.value;
                }
            } else if (this.type === 'address') {
                if (this.index != null) {
                    // @ts-ignore
                    this.detail = this.data[this.index].controls.input_ad.value;
                    // @ts-ignore
                    this.default = this.data[this.index].controls.select_ad.value;
                }

            }
            const isDefault = this.default ? ' [Default]' : '';
            this.dataDetail.push({
                key:  this.type ?? '',
                type: GenericPayloadType.text,
                label: this.capitalize(this.type),
                value: this.detail + isDefault
            });

        }
    }

    onClose() {
        this.cancel.emit('close');
    }

    onDelete() {
        this.cancel.emit('delete');
    }

    capitalize(str: string | undefined): string {
        if (typeof str === 'undefined') {
            return '';
        }
        const lower = str.toLowerCase();
        return str.charAt(0).toUpperCase() + lower.slice(1);
    }
}
